import React from 'react'
const Error = () => {
    return (
        <div className="p-5">
            <h1>City not found </h1>
            <p>Maybe the city you are looking for is not available on our site</p>
            <p>Check it and try with a valid one :)</p>
            <p>Si cela ne fonctionne pas encore, alors nous sommes désolés, il semble que nous ayons atteint le taux d'appel limité par jour</p>
        </div>
    )
}

export default Error
